import React from 'react'
import './TPMS_Flow2.css'

const TPMS_Flow2 = () => {
  const steps = [
    { id: 1, title: 'Video Acquisition', icon: 'bi-sign-turn-right' },
    { id: 2, title: 'AI Vehicle Detection', icon: 'bi-camera-video' },
    { id: 3, title: 'Intelligent Vehicle Tracking', icon: 'bi-search' },
    { id: 4, title: 'Evidence and Data Collection', icon: 'bi-credit-card' },
    { id: 5, title: 'Centralized Monitoring and Analysis', icon: 'bi-shield-check' },
   
  ]

  //   return (
  //     <div className="tpms-wrapper">

  //       {/* Top Heading Area */}
  //       <div className="tpms-header-section">
  //         <h1 className="tpms-main-title">Toll Processing Management System</h1>
  //         <div className="tpms-subtitle">Complete Workflow Infographic</div>
  //       </div>
  //       <div className='container-fluid'>
  // <div className='row'>
  // <div className='col-12 col-sm-6 col-md-6'>
  // kjhgf
  // </div>
  // <div className='col-12 col-sm-6 col-md-6 bg-dark'>
  // <div className="circle-container">

  //         {/* --- BACKGROUND SVG RING (The Blue Arrows) --- */}
  //         <svg className="ring-svg" viewBox="0 0 100 100">
  //           <defs>
  //             <linearGradient id="techBlue" x1="0%" y1="0%" x2="100%" y2="100%">
  //               <stop offset="0%" stopColor="#0056D2" /> {/* Dark Blue */}
  //               <stop offset="100%" stopColor="#00A0E3" /> {/* Light Blue */}
  //             </linearGradient>
  //           </defs>

  //           {/* We render segments based on the 7 steps */}
  //           {steps.map((_, i) => {
  //             const total = 7;
  //             // 360 degrees / 7 = 51.4 degrees per segment
  //             const anglePerSegment = 360 / total;
  //             // We want the arc to be slightly smaller than the full segment to leave a gap
  //             const arcLength = anglePerSegment - 4;

  //             const startAngle = (i * anglePerSegment) + 2; // +2 for centering the gap
  //             const endAngle = startAngle + arcLength;

  //             return (
  //               <g key={i}>
  //                 {/* The Arc Path */}
  //                 <path
  //                   d={describeArc(50, 50, 35, startAngle, endAngle)}
  //                   fill="none"
  //                   stroke="url(#techBlue)"
  //                   strokeWidth="1.2"
  //                   strokeLinecap="round"
  //                 />
  //                 {/* The Arrowhead */}
  //                 <polygon
  //                   points="0,0 -3,-4 3,-4" // Simple Arrow shape
  //                   fill="url(#techBlue)"
  //                   transform={`rotate(${endAngle}, 50, 50) translate(${50 + 35 * Math.cos(endAngle * Math.PI/180)}, ${50 + 35 * Math.sin(endAngle * Math.PI/180)}) rotate(${endAngle + 90})`}
  //                 />
  //               </g>
  //             );
  //           })}
  //         </svg>

  //         {/* --- CENTER HUB --- */}
  //         <div className="center-hub">
  //           <div className="hub-inner">
  //             <div className="hub-title">HOW OUR<br/>SYSTEM WORKS</div>
  //             <div className="hub-number">07</div>
  //             <div className="hub-sub">STEPS</div>
  //           </div>
  //         </div>

  //         {/* --- OUTER STEPS (7 Items) --- */}
  //         <div className="steps-container">
  //           {steps.map((step, i) => {
  //             // Calculate position in a circle
  //             const angle = (i * (360 / 7)) - 90; // -90 to start at top
  //             const radius = 35; // Same radius as SVG ring

  //             // Trig to get X/Y %
  //             const x = 50 + radius * Math.cos(angle * Math.PI / 180);
  //             const y = 50 + radius * Math.sin(angle * Math.PI / 180);

  //             return (
  //               <div
  //                 key={step.id}
  //                 className="step-bubble"
  //                 style={{
  //                   left: `${x}%`,
  //                   top: `${y}%`
  //                 }}
  //               >
  //                 {/* Number Badge */}
  //                 <div className="step-num">{step.id}</div>

  //                 {/* Icon Circle */}
  //                 <div className="step-icon-box">
  //                   <i className={`bi ${step.icon}`}></i>
  //                 </div>

  //                 {/* Title Text */}
  //                 <div className="step-text">{step.title}</div>
  //               </div>
  //             );
  //           })}
  //         </div>

  //       </div>
  // </div>
  // </div>
  // </div>
  //       {/* Circular Diagram Area */}

  //       {/* Bottom Footer Text */}
  //       <div className="tpms-footer">
  //         STEP UP TO GROWTH
  //       </div>

  //     </div>
  //   );

  return (
    <div className='container-fluid bg-system'>
      {/* Top Heading Area */}

      <div className='tpms-header-section'>
        <h1 className='tpms-main-title'>How TPMS Works</h1>
      </div>
      <div className='row'>
        {/* <div className='col-12 col-sm-6 col-md-6'>
kjhgf
</div> */}
        <div className='col-12 col-sm-6 col-md-6 left-content'>
          <div className='content-item'>
            <div className='content-number'>1</div>
            <div className='content-text'>
              <h4>Video Acquisition</h4>
              <p>
                TPMS receives video from existing compatible toll plaza cameras
                through live camera streams or recorded video files.
              </p>
            </div>
          </div>

          <div className='content-item'>
            <div className='content-number'>2</div>
            <div className='content-text'>
              <h4>AI Vehicle Detection</h4>
              <p>
                The AI engine identifies vehicles appearing in the monitored
                camera footage and recognizes configured vehicle categories.
              </p>
            </div>
          </div>

          <div className='content-item'>
            <div className='content-number'>3</div>
            <div className='content-text'>
              <h4>Intelligent Vehicle Tracking</h4>
              <p>
                Detected vehicles are tracked across video frames, including
                when they slow down or stop near toll barriers.
              </p>
            </div>
          </div>

          <div className='content-item'>
            <div className='content-number'>4</div>
            <div className='content-text'>
              <h4>Evidence and Data Collection</h4>
              <p>
                TPMS captures relevant vehicle images, video evidence, vehicle
                classification information, and recording timestamps for
                verification and reporting.
              </p>
            </div>
          </div>

          <div className='content-item'>
            <div className='content-number'>5</div>
            <div className='content-text'>
              <h4>Centralized Monitoring and Analysis</h4>
              <p>
                Vehicle records and operational information are presented
                through the TPMS dashboard. Where toll transaction data is
                integrated, operators can investigate discrepancies, review
                exemptions, and identify potential revenue leakage.
              </p>
            </div>
          </div>
        </div>

        <div className='col-12 col-sm-6 col-md-6 bg-dark1'>
          <div className='circle-container'>
            {/* --- BACKGROUND SVG RING (The Blue Arrows) --- */}
            <svg className='ring-svg' viewBox='0 0 100 100'>
              <defs>
                <linearGradient
                  id='techBlue'
                  x1='0%'
                  y1='0%'
                  x2='100%'
                  y2='100%'
                >
                  <stop offset='0%' stopColor='#0056D2' /> {/* Dark Blue */}
                  <stop offset='100%' stopColor='#00A0E3' /> {/* Light Blue */}
                </linearGradient>
              </defs>

              {/* We render segments based on the 7 steps */}
              {steps.map((_, i) => {
                const total = 5
                // 360 degrees / 7 = 51.4 degrees per segment
                const anglePerSegment = 360 / total
                // We want the arc to be slightly smaller than the full segment to leave a gap
                const arcLength = anglePerSegment - 4

                const startAngle = i * anglePerSegment + 2 // +2 for centering the gap
                const endAngle = startAngle + arcLength

                return (
                  <g key={i}>
                    {/* The Arc Path */}
                    <path
                      d={describeArc(50, 50, 35, startAngle, endAngle)}
                      fill='none'
                      stroke='url(#techBlue)'
                      strokeWidth='1.2'
                      strokeLinecap='round'
                    />
                    {/* The Arrowhead */}
                    <polygon
                      points='0,0 -3,-4 3,-4' // Simple Arrow shape
                      fill='url(#techBlue)'
                      transform={`rotate(${endAngle}, 50, 50) translate(${
                        50 + 35 * Math.cos((endAngle * Math.PI) / 180)
                      }, ${
                        50 + 35 * Math.sin((endAngle * Math.PI) / 180)
                      }) rotate(${endAngle + 90})`}
                    />
                  </g>
                )
              })}
            </svg>

            {/* --- CENTER HUB --- */}
            <div className='center-hub'>
              <div className='hub-inner'>
                <div className='hub-title'>
                  HOW OUR
                  <br />
                  SYSTEM WORKS
                </div>
                <div className='hub-number'>05</div>
                <div className='hub-sub'>STEPS</div>
              </div>
            </div>

            {/* --- OUTER STEPS (7 Items) --- */}
            <div className='steps-container'>
              {steps.map((step, i) => {
                // Calculate position in a circle
                const angle = i * (360 / 5) - 90 // -90 to start at top
                const radius = 35 // Same radius as SVG ring

                // Trig to get X/Y %
                const x = 50 + radius * Math.cos((angle * Math.PI) / 180)
                const y = 50 + radius * Math.sin((angle * Math.PI) / 180)

                return (
                  <div
                    key={step.id}
                    className='step-bubble'
                    style={{
                      left: `${x}%`,
                      top: `${y}%`
                    }}
                  >
                    {/* Number Badge */}
                    <div className='step-num'>{step.id}</div>

                    {/* Icon Circle */}
                    <div className='step-icon-box'>
                      <i className={`bi ${step.icon}`}></i>
                    </div>

                    {/* Title Text */}
                    <div className='step-text'>{step.title}</div>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

// Helper function to generate SVG Arc path
function polarToCartesian (centerX, centerY, radius, angleInDegrees) {
  var angleInRadians = ((angleInDegrees - 90) * Math.PI) / 180.0
  return {
    x: centerX + radius * Math.cos(angleInRadians),
    y: centerY + radius * Math.sin(angleInRadians)
  }
}

function describeArc (x, y, radius, startAngle, endAngle) {
  var start = polarToCartesian(x, y, radius, endAngle)
  var end = polarToCartesian(x, y, radius, startAngle)
  var largeArcFlag = endAngle - startAngle <= 180 ? '0' : '1'
  var d = [
    'M',
    start.x,
    start.y,
    'A',
    radius,
    radius,
    0,
    largeArcFlag,
    0,
    end.x,
    end.y
  ].join(' ')
  return d
}

export default TPMS_Flow2
